import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/app/page.tsx");
